export const APP_LOADING = 'appLoading'
export const APP_REFRESH_CONFIG = 'refreshAppConfig'
export const APP_REQUEST_CONFIG = 'requestAppConfig'
export const APP_SET_LANG = 'setAppLang'
export const APP_START_LOADING = 'startAppLoading'
export const APP_STOP_LOADING = 'stopAppLoading'
